var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import amexIconSrc from '@images/icons/new/payment/amex.png';
import discoverIconSrc from '@images/icons/new/payment/discover.png';
import masterCardIconSrc from '@images/icons/new/payment/mastercard.png';
import visaIconSrc from '@images/icons/new/payment/visa.png';
import { Asterisk, PoweredByStripe } from '@marketing/components/funnel/Icons/Icons';
import Tooltip from '@marketing/components/funnel/ProductCard/Tooltip';
import * as Sentry from '@sentry/browser';
import { CardCvcElement, CardExpiryElement, CardNumberElement, Elements, PaymentRequestButtonElement, useElements, useStripe, } from '@stripe/react-stripe-js';
import { clsx } from 'clsx';
import { useEffect, useState } from 'react';
import { useProfileContext } from '../ProfileContext';
import { isJuicyProfile } from '../utils';
import LineWithRoundedCaps from './LineWithRoundedCaps';
import { formatDollarsText } from '@utils/formatting_utils';
import { getStripe } from '@utils/payment_utils';
import { DELIVERY_INTERVALS_DISPLAY_MAP, SUBSCRIPTION_TYPES } from '@variables';
var PaymentTermsText = function () {
    var _a = useProfileContext().profileData, orderCosts = _a.orderCosts, postTrialPriceDetails = _a.postTrialPriceDetails, version = _a.version, deliveryInterval = _a.deliveryInterval;
    var salesTaxText = orderCosts.salesTax > 0 ? ' + tax' : '';
    var postTaxFeesText = orderCosts.fees.length > 0 ? ' + fees' : '';
    var deliveryIntervalToUse = isJuicyProfile(version)
        ? postTrialPriceDetails.deliveryInterval
        : deliveryInterval;
    return (_jsxs("p", { children: ["You agree to the", ' ', _jsx("a", __assign({ href: "/tos", target: "_blank" }, { children: "Terms" })), ' ', "and", ' ', _jsx("a", __assign({ href: "https://www.mars.com/privacy", target: "_blank", rel: "noreferrer" }, { children: "Privacy Policy" })), ", and place your first order of ", formatDollarsText(orderCosts.costAfterPromo), salesTaxText, postTaxFeesText, ". Your account will be created after your first order.", version !== SUBSCRIPTION_TYPES.OTTO && (_jsxs("span", { children: [' ', "Your regular subscription will be charged every", ' ', DELIVERY_INTERVALS_DISPLAY_MAP[deliveryIntervalToUse], ". You can reschedule, adjust or cancel future orders at any time."] }))] }));
};
var StripeBrowserPaymentApiForm = function (_a) {
    var setDisableForm = _a.setDisableForm;
    var _b = useProfileContext(), orderCosts = _b.profileData.orderCosts, signup = _b.signup;
    var stripe = useStripe();
    var _c = useState(null), paymentRequest = _c[0], setPaymentRequest = _c[1];
    useEffect(function () {
        if (stripe) {
            var paymentRequest_1 = stripe.paymentRequest({
                country: 'US',
                currency: 'usd',
                total: {
                    label: 'NomNomNow subscription',
                    amount: Math.round(orderCosts.totalCostWithTaxAndFees * 100), // Convert to cents
                },
            });
            paymentRequest_1.on('token', function (_a) {
                var complete = _a.complete, token = _a.token;
                setDisableForm(true);
                complete('success');
                var failureCallback = function () { return setDisableForm(false); };
                signup(token.id, failureCallback);
            });
            paymentRequest_1.on('cancel', function () {
                setDisableForm(false);
            });
            paymentRequest_1.canMakePayment().then(function (result) {
                if (result) {
                    setPaymentRequest(paymentRequest_1);
                }
            });
        }
    }, [stripe]);
    if (!paymentRequest) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(PaymentRequestButtonElement, { options: {
                    paymentRequest: paymentRequest,
                    style: {
                        paymentRequestButton: {
                            height: '38px',
                        },
                    },
                } }), _jsx("div", __assign({ className: "font-medium" }, { children: "or" }))] }));
};
var PaymentInformationBlock = function (_a) {
    var setDisableForm = _a.setDisableForm;
    var _b = useProfileContext(), _c = _b.profileData, postTrialPriceDetails = _c.postTrialPriceDetails, version = _c.version, serverLoading = _b.serverLoading;
    var PAYMENT_METHOD_ICONS = {
        'American Express': amexIconSrc,
        'Discover': discoverIconSrc,
        'MasterCard': masterCardIconSrc,
        'Visa': visaIconSrc,
    };
    var deliveryIntervalDisplayText = DELIVERY_INTERVALS_DISPLAY_MAP[postTrialPriceDetails.deliveryInterval];
    return (_jsxs("div", __assign({ className: "grid grid-cols-1 gap-4 text-center" }, { children: [_jsxs("div", __assign({ className: "grid grid-cols-1 gap-6" }, { children: [isJuicyProfile(version) && (_jsxs("p", { children: ["After trial: ", formatDollarsText(postTrialPriceDetails.costPerWeek), " per week, billed and shipped ", deliveryIntervalDisplayText, "."] })), _jsxs("div", __assign({ className: "flex flex-row items-center justify-center gap-2" }, { children: [_jsx(Asterisk, {}), _jsx("span", __assign({ className: "inline-block" }, { children: " = required fields" }))] }))] })), _jsx("h2", __assign({ className: "font-medium" }, { children: "Payment Information" })), !serverLoading && _jsx(StripeBrowserPaymentApiForm, { setDisableForm: setDisableForm }), _jsx("div", __assign({ className: "flex justify-center items-center gap-2" }, { children: Object.keys(PAYMENT_METHOD_ICONS).map(function (paymentMethod) { return (_jsx("img", { className: "inline-block", src: PAYMENT_METHOD_ICONS[paymentMethod], alt: paymentMethod }, "payment-method-".concat(paymentMethod))); }) }))] })));
};
var StripeElementWrapper = function (_a) {
    var children = _a.children, id = _a.id, label = _a.label, tooltip = _a.tooltip, errorMessage = _a.errorMessage;
    return (_jsxs("div", __assign({ className: "w-full flex flex-col gap-1" }, { children: [_jsx("div", __assign({ className: "!text-md-med-m !md:text-md-med-d" }, { children: children })), _jsx(LineWithRoundedCaps, {}), _jsxs("label", __assign({ htmlFor: id, className: "flex justify-center items-center gap-1 text-sm-reg-m md:text-sm-reg-d" }, { children: [_jsx("span", { children: label }), _jsx(Asterisk, {}), tooltip && _jsx(Tooltip, { children: tooltip })] })), errorMessage && (_jsx("div", __assign({ className: clsx('border-error-red bg-surface-white', 'w-full border-2 rounded-sm2 p-2xs-gutter text-center') }, { children: _jsx("span", __assign({ id: "".concat(id, "Error"), className: "text-sm-reg-m md:text-sm-reg-d text-center self-center" }, { children: errorMessage })) })))] })));
};
var CardForm = function (_a) {
    var _b, _c, _d;
    var disableForm = _a.disableForm, setDisableForm = _a.setDisableForm, _e = _a.formId, formId = _e === void 0 ? 'stripe-payment-form' : _e;
    var _f = useProfileContext(), serverLoading = _f.serverLoading, signup = _f.signup;
    var stripe = useStripe();
    var elements = useElements();
    var _g = useState({
        empty: true,
        complete: false,
        error: null,
    }), cardNumberStatus = _g[0], setCardNumberStatus = _g[1];
    var _h = useState({
        empty: true,
        complete: false,
        error: null,
    }), cardExpiresStatus = _h[0], setCardExpiresStatus = _h[1];
    var _j = useState({ empty: true, complete: false, error: null }), cardCvcStatus = _j[0], setCardCvcStatus = _j[1];
    useEffect(function () {
        var anyEmpty = cardNumberStatus.empty || cardExpiresStatus.empty || cardCvcStatus.empty;
        var anyError = cardNumberStatus.error || cardExpiresStatus.error || cardCvcStatus.error;
        setDisableForm(serverLoading || anyEmpty || !!anyError);
    }, [cardNumberStatus, cardExpiresStatus, cardCvcStatus, serverLoading]);
    var disableStripeElements = function (disabled) {
        var numberElement = elements.getElement(CardNumberElement);
        var cvcElement = elements.getElement(CardCvcElement);
        var expiryElement = elements.getElement(CardExpiryElement);
        if (numberElement && cvcElement && expiryElement) {
            elements.getElement(CardNumberElement).update({ disabled: disabled });
            elements.getElement(CardCvcElement).update({ disabled: disabled });
            elements.getElement(CardExpiryElement).update({ disabled: disabled });
        }
    };
    var handleErrors = function (error) {
        if (error) {
            console.error(error);
        }
        setDisableForm(false);
        disableStripeElements(false);
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    e.preventDefault();
                    if (disableForm || serverLoading) {
                        return [2 /*return*/];
                    }
                    if (!stripe || !elements) {
                        handleErrors("We're sorry, something went wrong. Please reload and try again.");
                        return [2 /*return*/];
                    }
                    setDisableForm(true);
                    disableStripeElements(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, stripe.createToken(elements.getElement(CardNumberElement))];
                case 2:
                    response = _c.sent();
                    if ((_a = response === null || response === void 0 ? void 0 : response.token) === null || _a === void 0 ? void 0 : _a.id) {
                        return [2 /*return*/, signup(response.token.id, handleErrors)];
                    }
                    handleErrors(((_b = response === null || response === void 0 ? void 0 : response.error) === null || _b === void 0 ? void 0 : _b.message) ||
                        'We were unable to process your subscription. Please contact us.');
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    handleErrors('We were unable to process your subscription. Please contact us.');
                    Sentry.captureException(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCardNumberChange = function (e) {
        setCardNumberStatus({ empty: e.empty, complete: e.complete, error: e.error });
    };
    var handleCardExpiresChange = function (e) {
        setCardExpiresStatus({ empty: e.empty, complete: e.complete, error: e.error });
    };
    var handleCardCvcChange = function (e) {
        setCardCvcStatus({ empty: e.empty, complete: e.complete, error: e.error });
    };
    var options = {
        style: {
            base: {
                'fontFamily': 'GTAmerica, sans-serif',
                'fontSize': '16px',
                'fontWeight': '500',
                'letterSpacing': '-0.02em',
                'textAlign': 'center',
                ':disabled': {
                    color: '#656565',
                },
            },
            invalid: {
                color: '#dc2626',
            },
        },
    };
    return (_jsxs("form", __assign({ onSubmit: handleSubmit, id: formId, className: "grid grid-cols-1 gap-8" }, { children: [_jsx(StripeElementWrapper, __assign({ id: "stripe-card-number", label: "Card Number", errorMessage: (_b = cardNumberStatus.error) === null || _b === void 0 ? void 0 : _b.message }, { children: _jsx(CardNumberElement, { id: "stripe-card-number", options: options, onChange: handleCardNumberChange }) })), _jsx(StripeElementWrapper, __assign({ id: "stripe-card-expiry", label: "Expiration", errorMessage: (_c = cardExpiresStatus.error) === null || _c === void 0 ? void 0 : _c.message }, { children: _jsx(CardExpiryElement, { id: "stripe-card-expiry", options: options, onChange: handleCardExpiresChange }) })), _jsx(StripeElementWrapper, __assign({ id: "stripe-card-cvc", label: "Security Code", tooltip: "The 3-4 digit number on the back of your credit card.", errorMessage: (_d = cardCvcStatus.error) === null || _d === void 0 ? void 0 : _d.message }, { children: _jsx(CardCvcElement, { id: "stripe-card-cvc", options: options, onChange: handleCardCvcChange }) })), _jsx("div", __assign({ className: "mx-auto" }, { children: _jsx(PoweredByStripe, {}) }))] })));
};
var StripePaymentForm = function (_a) {
    var disableForm = _a.disableForm, setDisableForm = _a.setDisableForm, _b = _a.formId, formId = _b === void 0 ? 'stripe-payment-form' : _b;
    return (_jsxs("div", __assign({ className: "grid grid-cols-1 gap-16" }, { children: [_jsxs(Elements, __assign({ stripe: getStripe() }, { children: [_jsx(PaymentInformationBlock, { setDisableForm: setDisableForm }), _jsx(CardForm, { disableForm: disableForm, setDisableForm: setDisableForm, formId: formId })] })), _jsx(PaymentTermsText, {})] })));
};
export default StripePaymentForm;
